
import React from 'react';
import { Control } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { AlertTriangle } from 'lucide-react';

interface Client {
  id: string;
  name: string;
  has_active_license?: boolean;
}

interface UserFormData {
  name?: string;
  email?: string;
  phone?: string;
  department?: string;
  role?: string;
  client_id?: string;
  client_ids?: string[];
  status?: 'active' | 'inactive';
  groups?: string[];
}

interface UserClientFieldProps {
  control: Control<UserFormData>;
  clients: Client[];
}

export const UserClientField = ({ control, clients }: UserClientFieldProps) => {
  return (
    <FormField
      control={control}
      name="client_ids"
      render={({ field }) => {
        const currentClients = field.value || [];
        
        return (
          <FormItem>
            <FormLabel>Clientes (Multi-Cliente)</FormLabel>
            <div className="grid grid-cols-2 gap-2 max-h-32 overflow-y-auto border rounded-md p-3 bg-background">
              {clients.length === 0 ? (
                <div className="col-span-2 text-sm text-muted-foreground text-center py-2">
                  Nenhum cliente disponível
                </div>
              ) : (
                clients.map((client) => (
                  <div key={client.id} className="flex items-center space-x-2">
                    <Checkbox
                      id={`client-${client.id}`}
                      checked={currentClients.includes(client.id)}
                      onCheckedChange={(checked) => {
                        let newClients;
                        if (checked) {
                          newClients = [...currentClients, client.id];
                        } else {
                          newClients = currentClients.filter(id => id !== client.id);
                        }
                        field.onChange(newClients);
                      }}
                    />
                    <label
                      htmlFor={`client-${client.id}`}
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer flex items-center gap-1"
                    >
                      {client.name}
                      {client.has_active_license === false && (
                        <span className="inline-flex items-center gap-0.5 text-xs text-destructive" title="Cliente sem licença ativa">
                          <AlertTriangle className="h-3 w-3" />
                          <span className="text-[10px]">Sem licença</span>
                        </span>
                      )}
                    </label>
                  </div>
                ))
              )}
            </div>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};